<ng-content></ng-content>
@if (help()) {
<span class="av-tooltip-point">?</span>
} @if (enabled()) {
<span
  #tooltip
  role="tooltip"
  class="av-tooltip av-tooltip-{{ position() }}"
  [class.av-tooltip-wrap]="wrap()"
  [class.av-tooltip-detached]="detached()"
  [attr.popover]="detached() ? 'manual' : null"
  translate
>
  <ng-content select="[tooltipMessage]"></ng-content>
  {{ message() }}
</span>
}
